import { useState } from "react";
import { History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const RecupererAnnonces = ({ onDone }) => {
  const [envoi, setEnvoi] = useState(false);
  const lancer = async () => {
    setEnvoi(true);
    try {
      const { data } = await api.post("/logements/recuperer-annonces");
      const retenus = Object.entries(data.retenus || {}).map(([c, noms]) => `${noms.map((n) => `« ${n} »`).join(", ")} → ${c}`);
      toast.success(`${data.completees} réservation(s) complétée(s) avec leur nom d'annonce (${data.annonces} nom(s) trouvé(s) dans vos fichiers)`);
      if (retenus.length) toast.info(`Retenu pour les prochains imports : ${retenus.join(" · ")}`, { duration: 10000 });
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setEnvoi(false); }
  };
  return (
    <div className="mb-3 flex flex-col gap-2 rounded-md border border-slate-200 bg-slate-50 p-3 sm:flex-row sm:items-center sm:justify-between" data-testid="recuperer-annonces">
      <p className="text-xs text-slate-600">Relit vos fichiers Airbnb / Booking déjà importés pour retrouver le nom d'annonce de chaque réservation, sans rien réimporter.</p>
      <Button size="sm" variant="outline" className="shrink-0 bg-white" disabled={envoi} onClick={lancer} data-testid="recuperer-annonces-button">
        {envoi ? <Loader2 className="mr-2 h-3.5 w-3.5 animate-spin" /> : <History className="mr-2 h-3.5 w-3.5" />}Récupérer les noms d'annonce
      </Button>
    </div>
  );
};
